import React from 'react';

/**
 * Componente de loading centralizado com design moderno.
 */
const LoadingSpinner = ({ text = 'Carregando...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">{text}</p>
    </div>
  );
};

export default LoadingSpinner;
